// Admin navigation types - matching admin-web structure exactly

export interface IRole {
  id: number;
  name: string;
  organizationId: number;
  organization: IOrganization;
  propertyId: number;
  property: IProperty;
}

export interface IUserState {
  // IMPORTANT: Any properties added to this interface should also be added to the whitelist in the userSlice
  id: number;
  email: string;
  firstName?: string;
  lastName?: string;
  isSuperUser?: boolean;
  organizations?: IOrganization[];
  properties?: IProperty[];
  roles?: IRole[];
  // Additional state for React Native
  isLoading?: boolean;
  emailCode?: string | null;
  accessToken?: string | null;
  selectedOrganizationId?: number;
  selectedPropertyId?: number;
}

export interface IOrganization {
  id: number;
  name: string;
  properties?: IProperty[];
}

export interface IProperty {
  id: number;
  marketingName: string;
  externalId?: number;
  organizationId?: number;
  propertyCashAccountId?: string;
  accountsPayableAccountId?: string;
  convenienceFeeAccountId?: string;
  email?: string;
  phone?: string;
  websites?: {
    home: string;
    handbook: string;
  };
  faqUrl?: string;
  cbxWifiInformationFilePath?: string;
  address?: string;
  photoUrl?: string;
  photos?: Array<any>;
  logoUrl?: string;
  accountingPeriodEndDate?: number;
  featureFlags?: any;
}

export interface INavigationBaseItem {
  path: string;
  title: string;
  description?: string;
  subNavItems?: INavigationBaseItem[];
  condition?: (user: IUserState) => boolean;
  displaySelectors?: string[];
}

export interface INavigationItem extends INavigationBaseItem {
  id: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  active?: boolean;
}

export const SELECTOR_OPTIONS = {
  property: "property",
  organization: "organization",
} as const;